import { AxiosError, isAxiosError } from "axios";
import isFetchNetworkError from "is-network-error";

import * as auth from "@skilitics/auth-client";

export const isFetchOrAxiosNetworkError = (error: unknown): boolean => {
  // Need to explicitly check for our custom NetworkError since apparently fetch() can throw non-network errors,
  // with pretty much arbitrary messages, and there somehow still isn't a good way to identify them.
  if (error instanceof auth.AuthNetworkError) {
    return true;
  }
  // Still fall back to is-network-error since we currently only have the above in auth.
  if (isFetchNetworkError(error)) {
    return true;
  }
  if (isAxiosError(error)) {
    return error.code === AxiosError.ERR_NETWORK || error.code === AxiosError.ETIMEDOUT;
  }
  if (error instanceof Error && error.cause) {
    return isFetchOrAxiosNetworkError(error.cause);
  }
  return false;
};
